/**
 * Recording duration limits — M3 / S-03-04, values from D-008 (ACTIVE).
 *
 * D-008 locks the SHAPE — one early soft warning, one higher hard safety cap,
 * no auto-split, recorded audio preserved at the cap — and names the initial
 * v1 values: **approximately 2 minutes for the warning, approximately 10
 * minutes for the cap.** They are implemented here exactly as 2 and 10
 * minutes, as the "named client-side constants with no schema dependency"
 * D-008's enforcement section calls for.
 *
 * TUNABLE, NOT ARCHITECTURAL. D-008 is explicit that these may be adjusted
 * from real use without a new product decision, as long as the locked shape
 * stays. Adjusting means editing THESE TWO VALUES — nothing else reads a
 * duration limit from anywhere else. `CaptureLifecycle.test.tsx` pins the
 * current values so an accidental edit cannot ship silently; a deliberate
 * tuning updates that pin in the same pass.
 *
 * THE TWO SERVE DIFFERENT PURPOSES AND ARE SET INDEPENDENTLY (D-008): the
 * warning does product work — it encourages a focused Capture while wrapping
 * up is still cheap, and recording CONTINUES through it. The cap does safety
 * work only — it bounds a forgotten or runaway recorder. Neither is the
 * recommended Capture length.
 *
 * The cap sits comfortably under the STT boundary's documented 25 MB upload
 * limit at any plausible voice bitrate (D-011), and the port's unrelated
 * 5-second STOP timeout (`RECORDER_STOP_TIMEOUT_MS`, D-017) is a different
 * bound on a different thing and does not live here.
 */

/** Soft warning threshold — D-008's ~2 minutes. Recording CONTINUES. */
export const RECORDING_WARNING_MS = 2 * 60 * 1000;

/** Hard safety cap — D-008's ~10 minutes. Recording stops SAFELY; the
 * completed audio is preserved for the explicit Transcribe / Discard choice. */
export const RECORDING_HARD_CAP_MS = 10 * 60 * 1000;
